"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("./index177.js");var i=t.isObject,o=function(e){return i(e)||e===null};exports.isPossiblePrototype=o;
